import { PaperAgentGetDocumentUrlInput } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

import { contractConfigurationClient } from 'src/api/client';

export async function uploadToS3(fileName: string, userName: string, file: File): Promise<string> {
    const response = await contractConfigurationClient
        .paperAgentGetDocumentUrl(
            PaperAgentGetDocumentUrlInput.clone({
                user: userName,
                documentName: fileName
            })
        )
        .toPromise();
    const signedUrl = response.url;
    const fetchResponse = await fetch(signedUrl, {
        method: 'PUT',
        body: file
    });

    if (!fetchResponse.ok) {
        const message = await fetchResponse.text();
        throw new Error(`${fetchResponse.status} ${fetchResponse.statusText}: ${message}`);
    }

    return response.s3Key;
}
